import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { EventService } from "@perxis-auto/shared/lib";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import { APP_EVENTS, APP_EVENT_BUTTON_IDS } from "../../../shared/config/events.js";
import "../../../shared/context/constructor.js";
import { useThisContext } from "../../../shared/context/this.js";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/shared";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import { formatVehicleTags } from "../../../shared/lib/format/vehicle/formatVehicleTags.js";
import "../../../shared/lib/logger/index.js";
import { useAppNavigate } from "../../../shared/lib/router/hooks/useAppNavigate.js";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import { selectTags } from "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const { redirects, formatVehicleTitle, formatVehicleDescription, formatVehicleStatus, ...props } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { t } = useTranslation(APP.name);
  const vehicleItem = useThisContext();
  const navigate = useAppNavigate();
  const eventService = EventService.getInstance();
  const { enable: isTagsEnable } = useAppSelector(selectTags);
  const title = vehicleItem ? formatVehicleTitle(vehicleItem) : null;
  const description = vehicleItem ? formatVehicleDescription(vehicleItem) : null;
  const status = useMemo(
    () => vehicleItem ? formatVehicleStatus(vehicleItem) : null,
    [formatVehicleStatus, vehicleItem]
  );
  const markers = useMemo(() => {
    if (isTagsEnable) {
      const tags = (vehicleItem == null ? void 0 : vehicleItem.data.tags) || [];
      return formatVehicleTags(tags);
    }
    if (status) {
      return formatVehicleTags([
        {
          id: "0",
          displayName: status.label.trim(),
          disabled: false
        }
      ]);
    }
    return [];
  }, [isTagsEnable, status, vehicleItem == null ? void 0 : vehicleItem.data.tags]);
  const onBackClick = useCallback(() => {
    navigate(redirects.onBackClick.to, redirects.onBackClick.options);
    eventService.sendEvent(APP_EVENTS.ButtonClicked, {
      id: APP_EVENT_BUTTON_IDS.BACK_TO_LIST_FROM_CAR_PAGE
    });
  }, [eventService, navigate, redirects.onBackClick.options, redirects.onBackClick.to]);
  return {
    ...props,
    title,
    description,
    status,
    markers,
    isTagsEnable,
    onBackClick,
    t
  };
};
export {
  useContainer
};
